import { useEffect } from "react";

/**
 * Substract previousTotal value on FWTotalDiff from
 * FWTotalChange value and set the result to FWTotalDiff.
 */
export const useMoonFWDiff = (
  tag: string,
  previousTotal: number | undefined = undefined,
  id: string,
  setValue: (id: string, value: string) => void,
) => {
  if (tag !== "FWTotalDiff" && tag !== "FWTotalChange") return;
  useEffect(() => {
    const calcDiff = () => {
      if (previousTotal === undefined) return;
      const input = document.querySelector<HTMLInputElement>(
        `div.FWTotalChange > input`,
      );
      const diff = input
        ? parseFloat(String(input.value || 0).replace(",", ".")) - previousTotal
        : 0;

      if (tag === "FWTotalDiff") {
        // Defer setValue to prevent interfering with tab navigation
        setTimeout(() => {
          setValue(id, diff !== null ? diff.toFixed(2).toString() : "");
        }, 0);
      }
    };

    calcDiff();

    // Attach blur event listener on FWTotalChange input
    const input = document.querySelector<HTMLInputElement>(
      `div.FWTotalChange > input`,
    );
    input?.addEventListener("blur", calcDiff);

    return () => {
      input?.removeEventListener("blur", calcDiff);
    };
  }, []);
};
